import { IconProps } from '../../../lib/types';

const Requirements: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.392"
      height="32.523"
      viewBox="0 0 24.392 32.523"
      className={className}
    >
      <path
        d="M21.343 4.065h-5.628a3.358 3.358 0 00.038-.508 3.557 3.557 0 10-7.114 0 3.358 3.358 0 00.038.508H3.049A3.05 3.05 0 000 7.114v22.36a3.05 3.05 0 003.049 3.049h18.294a3.05 3.05 0 003.049-3.049V7.114a3.05 3.05 0 00-3.049-3.049zM12.2 2.033a1.525 1.525 0 11-1.525 1.525A1.521 1.521 0 0112.2 2.033zm10.16 27.441a1.019 1.019 0 01-1.016 1.016H3.049a1.019 1.019 0 01-1.016-1.016V7.114A1.019 1.019 0 013.049 6.1H6.1v1.27a.764.764 0 00.762.762h10.67a.764.764 0 00.762-.762V6.1h3.049a1.019 1.019 0 011.017 1.014z"
        className="a"
      ></path>
    </svg>
  );
};

export default Requirements;
